import {produce} from "immer";


const checkMinMaxZoom = viewState => {
  const { zoom, minZoom, maxZoom } = viewState;
  const isDisableZoomOut = zoom <= minZoom;
  const isDisableZoomIn = zoom >= maxZoom;
  return {
    ...viewState,
    isDisableZoomOut,
    isDisableZoomIn,
  };
};


export const reducer = (viewState, action) => {
  const { payload } = action;
  let props;

  if ( action.type === ACTIONS.UPDATE_VIEWPORT ) {
    const { latitude, longitude, zoom } = payload;
    props = produce(viewState, draft => {
      draft.latitude = latitude;
      draft.longitude = longitude;
      if ( zoom )
        draft.zoom = zoom;
    });
  }

  else if ( action.type === ACTIONS.UPDATE_ZOOM ) {
    const { zoom } = payload;
    props = produce(viewState, draft => {
      draft.zoom = zoom;
    });
  }

  else if ( action.type === ACTIONS.ZOOM_IN ) {
    const {zoom, maxZoom} = viewState;
    const newZoom = zoom + 1;
    props = produce(viewState, draft => {
      draft.zoom = Math.min(newZoom, maxZoom || newZoom);
    });
  }

  else if ( action.type === ACTIONS.ZOOM_OUT ) {
    const {zoom, minZoom} = viewState;
    const newZoom = zoom - 1;
    props = produce(viewState, draft => {
      draft.zoom = Math.max(newZoom, minZoom || newZoom);
    });
  }

  props = checkMinMaxZoom(props);

  return props;
};

export const ACTIONS = {
  UPDATE_VIEWPORT: 'UPDATE_VIEWPORT',
  UPDATE_ZOOM: 'UPDATE_ZOOM',
  ZOOM_IN: 'ZOOM_IN',
  ZOOM_OUT: 'ZOOM_OUT',
};
